import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';

const SandAnalogsList = ({
  analogs,
  onSelectAnalog,
  colSpan,
  currentMaterial,
  isLoading,
  parentTableStructure = false,
  isOriginal = false,
}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSelect = (analog) => {
    // Передаем аналог и имя текущего материала для замены
    onSelectAnalog(analog, currentMaterial.name);
  };

  const filteredAnalogs = React.useMemo(() => {
    let filtered = analogs;

    // Фильтруем по поисковому запросу
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(analog =>
        analog.name.toLowerCase().includes(query) ||
        analog.manufacturer?.toLowerCase().includes(query)
      );
    }

    // Сортируем от самого дешевого к самому дорогому
    filtered = filtered.sort((a, b) => a.totalCost - b.totalCost);

    return filtered;
  }, [analogs, searchQuery]);

  const formatPrice = (price) => {
    return new Intl.NumberFormat('ru-RU').format(Math.ceil(price));
  };

  // Рассчитываем экономию для аналога
  const getSavings = (analog) => {
    const currentTotal = currentMaterial.totalCost || currentMaterial.sum || 0;
    return currentTotal - analog.totalCost;
  };

  if (isLoading) {
    return (
      <tr className="rd-kp-alts-row">
        <td colSpan={colSpan} className="rd-kp-alts-cell">
          <div className="rd-kp-alts">
            <div className="rd-kp-alts__empty">
              <CircularProgress size={20} />
              <div style={{ marginTop: '8px' }}>Поиск аналогов песка...</div>
            </div>
          </div>
        </td>
      </tr>
    );
  }

  // Подпись под названием: производитель · мкр/кф/класс · доставка
  const buildSubtitle = (item, isCurrent = false) => {
    const parts = [];
    if (item.manufacturer) parts.push(item.manufacturer);
    const sieve = [];
    if (item.mkr) sieve.push(`мкр ${item.mkr}`);
    if (item.kf) sieve.push(`кф ${item.kf}`);
    if (item.class) sieve.push(item.class);
    if (sieve.length) parts.push(sieve.join(', '));
    const delivery = isCurrent
      ? (item.realDeliveryMethod || item.deliveryMethod || 'Самовывоз')
      : (item.deliveryMethod || 'Самовывоз');
    if (delivery) parts.push(delivery);
    return parts.join(' · ');
  };

  return (
    <tr className="rd-kp-alts-row">
      <td colSpan={colSpan} className="rd-kp-alts-cell">
        <div className="rd-kp-alts">
          {/* Поиск */}
          <div className="rd-kp-alts__search">
            <input
              type="text"
              placeholder="Поиск по аналогам"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Текущий выбранный материал */}
          <div className="rd-kp-alts__row rd-kp-alts__row--picked">
            <div className="rd-kp-alts__title">
              {currentMaterial.name}
              <small>{buildSubtitle(currentMaterial, true)}</small>
            </div>
            <input className="rd-kp-alts__qty" value={currentMaterial.quantity} readOnly />
            <span className="rd-kp-alts__unit">{currentMaterial.unit}</span>
            <span className="rd-kp-alts__price">
              {formatPrice(currentMaterial.totalCost || currentMaterial.sum)} ₽
            </span>
            <button className="rd-kp-alts__choose" type="button">текущий</button>
          </div>

          {/* Аналоги */}
          {filteredAnalogs.length > 0 ? (
            filteredAnalogs.map((analog, index) => {
              const savings = getSavings(analog);
              return (
                <div className="rd-kp-alts__row" key={index}>
                  <div className="rd-kp-alts__title">
                    {analog.name}
                    <small>{buildSubtitle(analog)}</small>
                  </div>
                  <input className="rd-kp-alts__qty" value={analog.quantity} readOnly />
                  <span className="rd-kp-alts__unit">{analog.unit}</span>
                  <span className="rd-kp-alts__price">
                    {formatPrice(analog.totalCost)} ₽
                    {savings > 0 && <small>−{formatPrice(savings)} ₽</small>}
                  </span>
                  <button
                    className="rd-kp-alts__choose"
                    type="button"
                    onClick={() => handleSelect(analog)}
                  >
                    выбрать
                  </button>
                </div>
              );
            })
          ) : (
            <div className="rd-kp-alts__empty">
              {searchQuery ? 'Ничего не найдено по запросу' : 'Аналоги не найдены'}
            </div>
          )}
        </div>
      </td>
    </tr>
  );

};

export default SandAnalogsList;